import { useTranslation } from 'react-i18next'
import CardTemplate from './card-template'

const SubmittedRequest = ({ children, ...props }) => {
  const { t } = useTranslation()

  const creditDescription = t(
    'r.trust_score.trust_score_request_complete.text',
    "You're all set! Your Trust Score report will now be available to landlords whose units you apply to. Your credit check will be submitted to Equifax® when requested by landlords."
  )

  return (
    <CardTemplate
      userRole={props.userRole}
      title={props.title}
      creditDescription={creditDescription}
      creditRatingResult={t('r.trust_score.submitted.text', 'Submitted')}
      creditDetails={props.creditDetails}
      user={props.user}
      professionId={props.professionId}
      csoVerifiedState={props.csoVerifiedState}
      salarySort={props.salarySort}
      listingData={props.listingData}
      showDetails={props.showDetails}
      secureFiles={props.secureFiles}
      noDetails
      data-testid={props['data-testid']}
    >
      {children}
    </CardTemplate>
  )
}

SubmittedRequest.defaultProps = {
  userRole: 'tenant',
  title: ''
}

export default SubmittedRequest
